import React, { Component } from 'react'
import { Field, reduxForm } from 'redux-form'
import { withStyles } from '@material-ui/core/styles'
import cx from 'classnames'

// COMPONENTS
import { ButtonContained } from '../app-button/button'
import renderSelectField from './field/customSelect'
import MenuItem from '@material-ui/core/MenuItem'
import Spinner from '../spinner'

const styles = theme => ({
  form: {
    maxWidth: 340,
    width: '100%',
  },
  chip: {
    width: '100%',
    marginBottom: 16,
  },
  root: {
    paddingLeft: 21,
    paddingRight: 3,
    borderRadius: 4,
    height: 48,
    justifyContent: 'flex-start',
  },
  colorSecondary: {
    fontSize: 16,
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 1.5,
    letterSpacing: 'normal',
    color: 'rgb(0, 0, 0)',
  },
  deleteIcon: {
    color: '#000',
    marginLeft: 'auto',
    '&:hover': {
      color: '#000',
    },
  },
  label: {
    paddingLeft: 0,
  },
  fieldGroupe: {
    display: 'flex',
  },
  '@keyframes wiggle': {
    '33%': { transform: 'rotateZ(1deg)' },
    to: { transform: 'rotateZ(-1deg)' },
  },

  '@keyframes wiggle2': {
    '33%': { transform: 'rotateZ(1deg)' },
    to: { transform: 'rotateZ(-1deg)' },
  },

  wiggle: {
    willChange: 'transform',
    animationName: 'wiggle',
    animationDuration: '150ms',
    animationIterationCount: 4,
  },
  crmDescriptionSmall: {
    marginTop: '20px',
    marginBottom: '5px',
    opacity: '0.75',
    fontSize: '12px',
  },
  error: {
    padding: '10px 0',
    fontSize: '12px',
    color: '#ff4e44',
  },
})

class AmoCrmForm2 extends Component {
  handleClick = (classes, submitFailed) => {
    if (submitFailed) {
      this.form.classList.remove(classes.wiggle)

      void this.form.offsetWidth

      this.form.classList.add(classes.wiggle)
    }
  }

  render() {
    const {
      classes,
      handleSubmit,
      submitFailed,
      invalid,
      error,
      isFetching,
    } = this.props

    const menuItem = item => {
      return (
        <MenuItem value={item.id} key={item.id}>
          {item.name}
        </MenuItem>
      )
    }

    const pipelines = () => {
      let list = []

      for (let i in state.availablePipelines) {
        list.push(menuItem(state.availablePipelines[i]))
      }

      return list
    }

    return (
      <form
        onSubmit={handleSubmit}
        className={cx(
          classes.form,
          { [classes.wiggle]: submitFailed },
          { [classes.novalidate]: invalid }
        )}
        ref={form => (this.form = form)}
      >
        <div className={classes.crmDescriptionSmall}></div>
        <Field name="pipeline" component={renderSelectField}>
          <MenuItem value="" style={{ display: 'none' }}>
            <span style={{ color: 'rgb(0, 0, 0, 0.3)' }}>Выберите воронку</span>
          </MenuItem>
          {pipelines()}
        </Field>
        {error ? <div className={classes.error}>{error}</div> : ''}
        <ButtonContained
          style={{
            flexShrink: 0,
            fontSize: 16,
            width: '100%',
            height: 48,
            padding: 0,
            fontWeight: 700,
            color: '#fff',
          }}
          type="submit"
          color="secondary"
          onClick={() => this.handleClick(classes, submitFailed)}
          text={isFetching ? <Spinner /> : 'Далее'}
        />
      </form>
    )
  }
}

AmoCrmForm2 = reduxForm({
  form: 'AmoCrmForm2',
})(AmoCrmForm2)

export default withStyles(styles)(AmoCrmForm2)
